import {
    type DateDisplayFormat,
    type DateDisplayValue,
    formatDate,
} from '@/services/dateFormat';

export type FormattedDateProps = {
    value: DateDisplayValue;
    format?: DateDisplayFormat;
    locale?: string;
    className?: string;
};

const FormattedDate = ({
    value,
    format = 'medium',
    locale,
    className,
}: FormattedDateProps) => {
    const formatted = formatDate(value, format, locale);
    if (!formatted) {
        return null;
    }

    return <span className={className}>{formatted}</span>;
};

FormattedDate.displayName = 'FormattedDate';

export { FormattedDate };
